export const promisesHaveResolved = (promises: PromiseSettledResult<any>[]) => {
  return promises.every(promise => promise.status === 'fulfilled');
};
